import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';
import { SubtradeChannelDropdownComponent } from '../DomainData/SubtradeChannelDropdown.component';
import { TradeNameDropdownComponent } from '../DomainData/TradeNameDropdown.component';
import { TradeGroupDropdownComponent } from '../DomainData/TradeGroupDropdown.component';
import { RequestTypeDropdownComponent } from '../DomainData/RequestTypeDropdown.component';
import { EquipmentClassDropdownComponent } from '../DomainData/EquipmentClassDropdown.component';
import { EquipmentActivityDropdownComponent } from '../DomainData/EquipmentActivityDropdown.component';
import { dropDownValidator, hiddenDropDownValueValidator } from '../../validators/CustomValidators';

@Component({
  selector: 'my-activityreason-edit',
  templateUrl: './ActivityReasonEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => ActivityReasonEditComponent)}]
})
export class ActivityReasonEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @Input() public record: ent.ActivityReason;

    @ViewChild(RequestTypeDropdownComponent) public requestTypeDropdownComponent: RequestTypeDropdownComponent;
    @ViewChild(EquipmentClassDropdownComponent) public equipmentClassDropdownComponent: EquipmentClassDropdownComponent;
    @ViewChild(EquipmentActivityDropdownComponent) public equipmentActivityDropdownComponent: EquipmentActivityDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'code' : '',
          'name' : '',
          'requestType' : '',
          'hidRequestType' : '',
          'equipmentClass' : '',
          'equipmentActivity' : '',
          'inactive' : '',
        };
        
        this.form = fb.group(group);
    }


    ngOnInit(): void {
        this.form.controls['requestType'].setValidators(dropDownValidator);
        this.form.controls['hidRequestType'].setValidators(hiddenDropDownValueValidator);
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    requestTypeSelected(){
        var val = true;
        var form = this.form;
        if (form.controls.requestType.errors && form.controls.hidRequestType.errors){
            if (form.controls.requestType.errors.invalid && form.controls.hidRequestType.errors.invalid){
                val = false;
            }
        }
        return val;
    }

    requestTypeChange(event: any){
        
        this.record.RequestTypeID = event;
    }

    equipmentClassChange(event: any){
        
        this.record.EquipmentClassID = event;
        if (event < 0){
            this.record.EquipmentClassID = null;
        }
    }

    equipmentActivityChange(event: any){
        this.record.EquipmentActivityID = event;
        if (event < 0){
            this.record.EquipmentActivityID = null;
        }
    }

    
}